import { useHistory } from 'react-router-dom';
import UsersIcon from '../img/users.svg';
import FeesIcon from '../img/fees.svg';
import TransactionIcon from '../img/transaction.svg';
import AllAccessCheckIn from '../img/allaccesscheckin.svg';
import CheckInIcon from '../img/checkin.svg';
import DatabaseIcon from '../img/database.svg';

const DashboardPanel = ({
    accessLevel,
    roles,
}: {
    accessLevel: number;
    roles?: string[];
}) => {
    const history = useHistory();
    const isPayrollAdmin = accessLevel === 3 || (roles || []).includes('payrollAdmin');

    return (
        <div>
            <div className="button-container">
                {accessLevel >= 3 && (
                    <>
                        <label className="label-block">
                            <button
                                className="label-block__button"
                                onClick={() => history.push('/users')}
                            >
                                <img
                                    className="button-icon"
                                    src={UsersIcon}
                                    alt="Users Icon"
                                />
                            </button>
                            Users
                        </label>
                        <label className="label-block">
                            <button
                                className="label-block__button"
                                onClick={() => history.push('/fees')}
                            >
                                <img
                                    className="button-icon"
                                    src={FeesIcon}
                                    alt="Fees Icon"
                                />
                            </button>
                            Fees
                        </label>
                        <label className="label-block">
                            <button
                                className="label-block__button"
                                onClick={() => history.push('/transactions')}
                            >
                                <img
                                    className="button-icon"
                                    src={TransactionIcon}
                                    alt="Transaction Icon"
                                />
                            </button>
                            Transaction Lookup
                        </label>
                    </>
                )}
                {isPayrollAdmin && (
                    <label className="label-block">
                        <button
                            className="label-block__button"
                            onClick={() => history.push('/payroll')}
                        >
                            <img
                                className="button-icon"
                                src={UsersIcon}
                                alt="Payroll Icon"
                            />
                        </button>
                        Payroll
                    </label>
                )}
                {accessLevel >= 1 && (
                    <label className="label-block">
                        <button
                            className="label-block__button"
                            onClick={() => history.push('/kiosk')}
                        >
                            <img
                                className="button-icon"
                                src={CheckInIcon}
                                alt="Kiosk Icon"
                            />
                        </button>
                        Kiosk
                    </label>
                )}
                {accessLevel >= 2 && (
                    <label className="label-block">
                        <button
                            className="label-block__button"
                            onClick={() => history.push('/sales-summary')}
                        >
                            <img
                                className="button-icon"
                                src={FeesIcon}
                                alt="Sales Summary Icon"
                            />
                        </button>
                        Sales Summary
                    </label>
                )}
                {accessLevel >= 3 && (
                    <label className="label-block">
                        <button
                            className="label-block__button"
                            onClick={() => history.push('/sales-items')}
                        >
                            <img
                                className="button-icon"
                                src={FeesIcon}
                                alt="Sale Items Icon"
                            />
                        </button>
                        Sale Items
                    </label>
                )}
                {accessLevel >= 3 && (
                    <label className="label-block">
                        <button
                            className="label-block__button"
                            onClick={() => history.push('/admin/bans')}
                            style={{
                                background: '#3a1010',
                                border: '2px solid #ff5555',
                                color: '#fff',
                                fontSize: '2rem',
                                fontWeight: 900,
                            }}
                            aria-label="Bans"
                        >
                            🚫
                        </button>
                        Bans
                    </label>
                )}
                {accessLevel >= 3 && (
                    <label className="label-block">
                        <button
                            className="label-block__button"
                            onClick={() =>
                                history.push('/admin/bans/from-scan')
                            }
                            style={{
                                background: '#2a1414',
                                border: '2px solid #ff8855',
                                color: '#fff',
                                fontSize: '1.4rem',
                                fontWeight: 800,
                            }}
                            aria-label="Ban From Scan"
                        >
                            🚫📷
                        </button>
                        Ban From Scan
                    </label>
                )}
            </div>
            <div className="button-container">
                {accessLevel === 2 && (
                    <>
                        <label className="label-block">
                            <button
                                className="label-block__button"
                                onClick={() => history.push('/transactions')}
                            >
                                <img
                                    className="button-icon"
                                    src={TransactionIcon}
                                    alt="Transaction Icon"
                                />
                            </button>
                            Transaction Lookup
                        </label>
                    </>
                )}
                {accessLevel >= 1 && (
                    <>
                        <label className="label-block">
                            <button
                                className="label-block__button"
                                onClick={() => history.push('/guests')}
                            >
                                <img
                                    className="button-icon"
                                    src={DatabaseIcon}
                                    alt="Database Icon"
                                />
                            </button>
                            Guest Database
                        </label>
                        <label className="label-block">
                            <button
                                className="label-block__button"
                                onClick={() => history.push('/sso-roster')}
                            >
                                <img
                                    className="button-icon"
                                    src={AllAccessCheckIn}
                                    alt="SSO Roster Icon"
                                />
                            </button>
                            SSO Roster
                        </label>
                    </>
                )}
            </div>
        </div>
    );
};

export default DashboardPanel;
